import state from "../cadastro-empresa/state";

export default {
    veiculosDoc: (state:any) => {
        return state.form.veiculosDocumentos
    }
}
